import FingerprintPattern from 'lucide-react/dist/esm/icons/fingerprint-pattern.mjs';
import MousePointerClick from 'lucide-react/dist/esm/icons/mouse-pointer-click.mjs';
import ScanSearch from 'lucide-react/dist/esm/icons/scan-search.mjs';
import ShieldCheck from 'lucide-react/dist/esm/icons/shield-check.mjs';
import Wifi from 'lucide-react/dist/esm/icons/wifi.mjs';
import { SubscribeButton } from './SubscribeButton.jsx';

const FEATURES = [
  {
    Icon: ShieldCheck,
    title: 'Фишинг не пройдёт',
    body: 'Опасная страница закроется раньше, чем вы успеете оставить данные.',
  },
  {
    Icon: Wifi,
    title: 'Wi‑Fi под защитой',
    body: 'Проверяем соединение в кафе, аэропорту и отеле.',
  },
  {
    Icon: ScanSearch,
    title: 'Утечки под контролем',
    body: 'Предупредим, если ваши данные появятся в открытом доступе.',
  },
];

const STEPS = [
  { Icon: MousePointerClick, number: '01', label: 'Нажмите «Подключить»' },
  { Icon: FingerprintPattern, number: '02', label: 'Подтвердите на устройстве' },
  { Icon: ShieldCheck, number: '03', label: 'Защита активна' },
];

export function FeatureSection() {
  return (
    <section className="features section-shell" id="features">
      <h2>Защита, которую не нужно замечать</h2>
      <div className="feature-strip">
        {FEATURES.map(({ Icon, title, body }) => (
          <article className="feature" key={title}>
            <div className="feature__icon" aria-hidden="true">
              <Icon />
            </div>
            <div>
              <h3>{title}</h3>
              <p>{body}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export function ApprovalSection() {
  return (
    <section className="approval section-shell" id="how-it-works">
      <h2>Одно действие. Настоящее подтверждение.</h2>
      <div className="approval-steps">
        {STEPS.map(({ Icon, number, label }) => (
          <article className="approval-step" key={number}>
            <span className="approval-step__number">{number}</span>
            <div className="approval-step__icon" aria-hidden="true">
              <Icon />
            </div>
            <h3>{label}</h3>
          </article>
        ))}
      </div>
      <div className="privacy-line">
        <FingerprintPattern aria-hidden="true" />
        <p>
          Сайт не получает отпечаток или лицо — только криптографическое подтверждение.
        </p>
      </div>
    </section>
  );
}

export function FinalCta({ active, flow, onSubscribe }) {
  return (
    <section className="final-cta section-shell" id="terms">
      <img
        className="final-cta__orb final-cta__orb--left"
        src="/assets/bolt-protect-orb.webp"
        alt=""
        aria-hidden="true"
      />
      <div className="final-cta__content">
        <h2>Спокойствие начинается с одного касания.</h2>
        <SubscribeButton active={active} flow={flow} onClick={onSubscribe} location="footer" />
        <p>20 ₽ в день · Автопродление ежедневно · Отмена в любой момент</p>
      </div>
      <img
        className="final-cta__orb final-cta__orb--right"
        src="/assets/bolt-protect-orb.webp"
        alt=""
        aria-hidden="true"
      />
    </section>
  );
}
